"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectDepartment = void 0;
const base_1 = require("./base");
class IkeObjectDepartment extends base_1.IkeRestObject {
    constructor() {
        super(...arguments);
        this.className = 'Department';
        this.actionName = 'department';
    }
}
exports.IkeObjectDepartment = IkeObjectDepartment;
//# sourceMappingURL=department.object.js.map